// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"610":"ac13f0c5","744":"aef66c46","756":"47e611af","887":"f3019fb9","897":"b3a13931"}[chunkId] + ".chunk.js";
};